import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import withLabel from "../hocs/withLabel";
import withStaticMode from "../hocs/withStaticMode";
import BryxColors from "../types/theme";
const BryxInput = styled((props) => {
    const { onChange, inputRef, sx, error, errorText, placeholder, innerWidth, innerHeight, ...rest } = props;
    return (_jsx(TextField, { ...rest, onChange: onChange, inputRef: inputRef, variant: "outlined", error: error, helperText: errorText ?? undefined, placeholder: placeholder, autoComplete: "off", sx: { width: innerWidth, height: innerHeight ?? "58px" }, InputLabelProps: {
            shrink: true,
        } }));
})(({ theme, error }) => {
    const pallete = theme.palette.mode;
    return {
        "& .MuiInputBase-root": {
            padding: "12px 16px",
            fontFamily: "Open Sans",
            fontSize: "16px",
            height: "46px",
            color: error
                ? BryxColors.notify(pallete, "error")
                : pallete == "light"
                    ? BryxColors.brand(pallete, -2)
                    : BryxColors.brand("dark", 4),
            backgroundColor: pallete == "dark" && BryxColors.DarkMode.specialColors.popupBackground,
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: error ? BryxColors.notify(pallete, "error") : BryxColors.notify(pallete, "inactive"),
            "& input": {
                padding: "0px",
                border: "none",
                "&:focus": {
                    outline: "none",
                },
            },
            "& fieldset": {
                display: "none",
            },
            "&.Mui-focused": {
                borderWidth: "1px",
                borderColor: (error
                    ? BryxColors.notify(pallete, "error")
                    : pallete == "light"
                        ? BryxColors.brand(pallete, -2)
                        : BryxColors.brand("dark", 4)) + " !important",
            },
            "& legend": {
                display: "none",
            },
        },
        "& .MuiFormHelperText-root": {
            marginTop: "4px",
            marginLeft: "0px",
            fontSize: "13px",
            fontFamily: "Open Sans",
            "&.Mui-error": {
                color: `${BryxColors.lightNotify("error")} !important`,
            },
        },
    };
});
export default withStaticMode(withLabel(BryxInput));
